import styles from './SearchResultSummary.less';

import React, { Component, PropTypes } from 'react';

import Filters from 'Filters/Filters';

export default class SearchResultSummary extends Component {

  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    displayTotalCount: PropTypes.string
  };

  render() {
    const { isLoading, displayTotalCount } = this.props;

    return (
      <div className={styles.root}>
        <div className={styles.content}>
          {
            isLoading ? null : (
              <h1 key="text" data-automation="totalJobsMessage">
                <span className={styles.count} data-automation="totalJobsCount">
                  { displayTotalCount || '' }
                </span>
                <span
                  className={styles.text}>
                  { ` job${displayTotalCount !== '1' ? 's' : ''}` }
                  <span className={styles.textFound}> found</span>
                </span>
              </h1>
            )
          }
        </div>
        <Filters />
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultSummary/SearchResultSummary.js
 **/